import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class NotificationService {
  constructor(private toastr: ToastrService) { }

  public success = (body: string, title = 'SUCCESS'): void => {
    this.toastr.success(body, title, {
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      closeButton: true
    });
  }

  public error = (body: string, title = 'ERROR'): void => {
    this.toastr.error(body, title, {
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      closeButton: true
    });
  }

  public warning = (body: string, title = 'WARNING'): void => {
    this.toastr.warning(body, title, {
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      closeButton: true
    });
  }

  public info = (body: string, title = 'INFO'): void => {
    this.toastr.info(body, title, {
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      closeButton: true
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/notification.service.ts